import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { ProductCategoryList } from './ProductCategoryList';
import { ProductCategoryDatagrid } from './ProductCategoryDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { ProductCategory } from './ProductCategory';

export * from './ProductCategory';
export * from './ProductCategoryCreate';
export * from './ProductCategoryDatagrid';
export * from './ProductCategoryEdit';
export * from './ProductCategoryList';
export * from './ProductCategoryShow';

const ProductCategoriesBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'name', header: 'Name' },
	// { key: 'description', header: 'Description' },
	{ key: 'imageUrl', header: 'Image URL' },
	{ key: 'organization.name', header: 'Organization Name' }
];

export const ProductCategoriesData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: ProductCategory) => entity;

	const productCategoriesFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות מוצרים', exportFields, exportDataMapper)}
				{...props}
				filters={productCategoriesFilter}
				bulkActionButtons={<ProductCategoriesBulkActionButtons/>}
				title="PRODUCT_CATEGORIES"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <ProductCategoryList/> : <ProductCategoryDatagrid/>}
			</List>
		</Fragment>
	);
};
